<app-page-breadcrumb pageTitle="Responsables de aprobación"></app-page-breadcrumb>

<app-component-card>
  <!-- Toolbar -->
  <div class="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between mb-4">
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 flex-1">
      <div>
        <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Buscar</label>
        <input
          type="text"
          [(ngModel)]="filtroSearch"
          (ngModelChange)="buscar()"
          placeholder="Nombre, cargo o correo..."
          class="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500/20 focus:border-brand-300"
        />
      </div>
      <div>
        <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Estado</label>
        <select
          [(ngModel)]="filtroActive"
          (ngModelChange)="buscar()"
          class="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
        >
          <option value="">Todos</option>
          <option value="true">Activos</option>
          <option value="false">Inactivos</option>
        </select>
      </div>
    </div>
    <app-button variant="primary" (btnClick)="nuevo()">+ Nuevo responsable</app-button>
  </div>

  @if (error) {
    <p class="mb-3 text-sm text-error-600 dark:text-error-400">{{ error }}</p>
  }

  @if (loading) {
    <div class="flex justify-center py-8">
      <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-brand-500"></div>
    </div>
  } @else if (items.length === 0) {
    <p class="py-8 text-center text-sm text-gray-500 dark:text-gray-400">
      No hay responsables de aprobación registrados.
    </p>
  } @else {
    <div class="overflow-x-auto rounded-lg border border-gray-200 dark:border-gray-700">
      <table class="min-w-full text-sm">
        <thead class="bg-gray-50 dark:bg-gray-800">
          <tr>
            <th class="px-3 py-2 text-left font-medium text-gray-600 dark:text-gray-400">Usuario</th>
            <th class="px-3 py-2 text-left font-medium text-gray-600 dark:text-gray-400">Cargo</th>
            <th class="px-3 py-2 text-left font-medium text-gray-600 dark:text-gray-400">Correo</th>
            <th class="px-3 py-2 text-right font-medium text-gray-600 dark:text-gray-400 w-32">Monto máx.</th>
            <th class="px-3 py-2 text-center font-medium text-gray-600 dark:text-gray-400 w-24">Firma</th>
            <th class="px-3 py-2 text-left font-medium text-gray-600 dark:text-gray-400 w-28">Estado</th>
            <th class="px-3 py-2 text-right font-medium text-gray-600 dark:text-gray-400 w-40">Acciones</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-200 dark:divide-gray-700">
          @for (item of items; track trackById($index, item)) {
            <tr class="hover:bg-gray-50 dark:hover:bg-gray-800/50">
              <td class="px-3 py-2 font-medium text-gray-900 dark:text-white">{{ item.userFullName || '—' }}</td>
              <td class="px-3 py-2 text-gray-700 dark:text-gray-300">{{ item.cargo }}</td>
              <td class="px-3 py-2 text-gray-500 dark:text-gray-400">{{ item.email || item.userEmail }}</td>
              <td class="px-3 py-2 text-right text-gray-700 dark:text-gray-300">
                {{ item.approvalLimit !== null ? (item.approvalLimit | number:'1.2-2') : 'Sin límite' }}
              </td>
              <td class="px-3 py-2 text-center">
                @if (item.hasSignature) {
                  <app-badge color="success">Sí</app-badge>
                } @else {
                  <app-badge color="warning">No</app-badge>
                }
              </td>
              <td class="px-3 py-2">
                @if (item.isActive) {
                  <app-badge color="success">Activo</app-badge>
                } @else {
                  <app-badge color="light">Inactivo</app-badge>
                }
              </td>
              <td class="px-3 py-2">
                <div class="flex items-center justify-end gap-1">
                  <button type="button" (click)="editar(item)" title="Editar"
                    class="p-1.5 rounded-lg text-gray-500 hover:bg-gray-100 hover:text-brand-600 dark:text-gray-400 dark:hover:bg-gray-700">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                    </svg>
                  </button>
                  <button type="button" (click)="toggle(item)" [title]="item.isActive ? 'Desactivar' : 'Activar'"
                    class="p-1.5 rounded-lg text-gray-500 hover:bg-gray-100 hover:text-brand-600 dark:text-gray-400 dark:hover:bg-gray-700">
                    @if (item.isActive) {
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"/>
                      </svg>
                    } @else {
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                      </svg>
                    }
                  </button>
                  <button type="button" (click)="eliminar(item)" title="Eliminar"
                    class="p-1.5 rounded-lg text-gray-500 hover:bg-error-50 hover:text-error-600 dark:text-gray-400 dark:hover:bg-error-500/10">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6M1 7h22M9 7V4a1 1 0 011-1h4a1 1 0 011 1v3"/>
                    </svg>
                  </button>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</app-component-card>
